import { blocks } from '@yola/ws-sdk';
import analytics from 'src/js/modules/analytics';
import getParentBlockByElement from '../../../../blocks/helpers/get-parent-block-by-element';

const {
  segment: {
    constants: { events },
    trackers: { trackEvent },
  },
} = analytics;

const trackTextEditingCustomSpacingDialogDisplayed = ({
  targetElement,
  topParagraphSpacing,
  bottomParagraphSpacing,
  customLineHeight,
}) => {
  const blockElement = getParentBlockByElement(targetElement);
  const blockId = blocks.accessors.getBlockIdByElement(blockElement);
  const blockVariationId = blocks.accessors.getVariationIdByElement(blockElement);

  trackEvent(events.TEXT_EDITING_CUSTOM_SPACING_DIALOG_DISPLAYED, {
    blockId,
    blockVariationId,
    bottomParagraphSpacing,
    topParagraphSpacing,
    customLineHeight,
  });
};

export default trackTextEditingCustomSpacingDialogDisplayed;
